import { youtubeAdvertiserFilter } from '@/helpers/advertisers/advertiserFilters.helpers';
import { parsedAdvertisersMapper } from '@/helpers/advertisers/advertiserMappers.helpers';
import { RootState } from '@/store';
import { createSelector } from '@reduxjs/toolkit';
import { selectSharedApiClients } from '../sharedApi.selectors';

const selectYoutubeReportBuilder = (state: RootState) => state.youtubeReportBuilder;

export const selectYoutubeTemplates = createSelector(
  [selectYoutubeReportBuilder],
  ({ templates, templatesRequestId }) => ({
    templates,
    loadingTemplates: !!templatesRequestId,
  }),
);

export const selectYoutubeCampaigns = createSelector(
  [selectYoutubeReportBuilder],
  ({ campaigns, campaignsRequestId }) => ({
    campaigns,
    loadingCampaigns: !!campaignsRequestId,
  }),
);

export const selectYoutubeGeneratedReports = createSelector(
  [selectYoutubeReportBuilder],
  ({ generatedReports, generatedReportsRequestId, generatedReportsTotal }) => ({
    generatedReports,
    loadingGeneratedReports: !!generatedReportsRequestId,
    generatedReportsTotal,
  }),
);

export const selectYoutubeScheduledReports = createSelector(
  [selectYoutubeReportBuilder],
  ({ scheduledReports, scheduledReportsRequestId, scheduledReportsTotal }) => ({
    scheduledReports,
    loadingScheduledReports: !!scheduledReportsRequestId,
    scheduledReportsTotal,
  }),
);

const youtubeClientsSelector = (state: RootState) =>
  selectSharedApiClients(state, parsedAdvertisersMapper, youtubeAdvertiserFilter);

export const selectYoutubeClients = createSelector([youtubeClientsSelector], clients => clients);
